import {ComponentMetadata} from '../model/component-metadata.model';
import {landingSectionsSignal} from '../signal/common/landing-sections.signal';


export function setLandingSections(list: ComponentMetadata[]) {
  landingSectionsSignal.set(list);
}

export function clearLandingSections() {
  landingSectionsSignal.set([]);
}
